<template>
  <div style="height: 200%">
    El periodo de inscripción ha finalizado. ¡<b>367</b> inscripciones realizadas y <b>592</b> personas inscritas!
    <!-- El periodo de inscripción comenzará el <b> 26 de Junio</b>. -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
